var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",class:_vm.b([
    _vm.type,
    _vm.size,
    {
      block: _vm.block,
      loading: _vm.loading,
      disabled: _vm.disabled,
      rounded: _vm.rounded,
      plain: _vm.plain,
      unclickable: _vm.disabled || _vm.loading,
      'bottom-action': _vm.bottomAction
    }
  ]),attrs:{"type":_vm.nativeType,"disabled":_vm.disabled},on:{"click":_vm.onClick}},[(_vm.loading)?_c('loader',{attrs:{"size":"20px","color":_vm.type === 'default' ? 'black' : 'white'}}):_vm._e(),_vm._v(" "),_c('span',{class:_vm.b('text')},[_vm._t("default",[_vm._v(_vm._s(_vm.text))])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d3c0bde","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/plugins/jscom/omui/components/button/index.vue
// module id = TNxk
// module chunks = 76